import { render } from "./MyCorporateClients.vue?vue&type=template&id=26c3926f&scoped=true"
import script from "./MyCorporateClients.vue?vue&type=script&lang=js"
export * from "./MyCorporateClients.vue?vue&type=script&lang=js"

import "./MyCorporateClients.vue?vue&type=style&index=0&id=26c3926f&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c3926f"]])

export default __exports__